import PropTypes from 'prop-types';
import SearchBar from 'components/SearchBar';
import { useFeatureFlags } from '../../../../hooks/LaunchDarkly/useFeatureFlags';

const FilterSearchBar = ({ searchesAllowing, scrollerId, placeholder, container }) => {
	const { showSearchBarOnCustomFilters } = useFeatureFlags();

	const { enable } = (showSearchBarOnCustomFilters || []).find((val) => val.container === container) || {};

	if (!enable) {
		return;
	}
	return <SearchBar searchesAllowing={searchesAllowing} scrollerId={scrollerId} placeholder={placeholder} />;
};

FilterSearchBar.propTypes = {
	searchesAllowing: PropTypes.array,
	scrollerId: PropTypes.string,
	placeholder: PropTypes.string,
	container: PropTypes.string,
};

export default FilterSearchBar;
